module.exports = __webpack_public_path__ + "static/img/5.1b465f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/eng/5.png
// module id = lq/e
// module chunks = 0